export class WidgetTableRow {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "cells",
            "baseName": "cells",
            "type": "{ [key: string]: WidgetTableCell; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WidgetTableRow.attributeTypeMap;
    }
    constructor() {
    }
}
